import { withTranslation } from "react-i18next";
import React from "react";
import * as Constants from "../../../constants/Constants";

import * as utils from "../../../global/utils";
import * as Helpers from "../../../global/Helpers";

class OtpPopup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      otp: "",
      OtpSIB: Array(5).fill(""),
      isDisabled: true,
      timer: 60,
    };
    this.timerInterval = null;
  }

  componentDidMount() {
    this.startTimer();
  }
  reSendOTP = () => {
    var url =
      Constants.reSendUserToken +
      localStorage.getItem("username") +
      "/" +
      localStorage.getItem("WebCode");
    var reSendUserToken = utils.reSendUserToken(url);
    reSendUserToken
      .then((response) => {
        if (response.data) {
          Helpers.successNotify(
            this.props.t("ReSendOTPMSG"),
            this.props.i18n.language
          );
          this.startTimer();
        } else {
          Helpers.errorNotify(
            this.props.t("somethingwentwrong"),
            this.props.i18n.language
          );
        }
      })

      .catch((error) => {
        Helpers.errorNotify(
          this.props.t("somethingwentwrong"),
          this.props.i18n.language
        );
      });
  };

  startTimer = () => {
    this.setState({ isDisabled: true, timer: 60 });

    this.timerInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timer <= 1) {
          clearInterval(this.timerInterval);
          return { isDisabled: false, timer: 0 };
        }
        return { timer: prevState.timer - 1 };
      });
    }, 1000);
  };

  componentWillUnmount() {
    // Clear the timer when the component unmounts to avoid memory leaks
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  handleChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = this.state.OtpSIB.map((digit, i) =>
        i === index ? value : digit
      );

      this.setState({ OtpSIB: newOtp });

      // Move to next input if current input is filled
      if (value && index < this.state.OtpSIB.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }

      // Move to previous input if current input is empty and not the first input
      if (!value && index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };
  render() {
    var dir = "ltr";
    if (this.props.i18n.language === "ar") {
      dir = "rtl";
    }
    return (
      <div>
        <div
          className={
            "custom-popup custom-scrollable  " +
            localStorage.getItem(Constants.localStorageConstants.company_name) +
            "-CSS"
          }
          style={{ height: "250px", width: "540px" }}
        >
          <div className="custom-popup-header pt-2">
            <div className="  PopupHeaderTitle" style={{ fontSize: "14px" }}>
              {this.props.t("resetPassword")}{" "}
            </div>
            <div className="mr-3" style={{ marginLeft: "auto" }}>
              <span
                className="my-panel-extra-btn"
                style={{
                  marginLeft: "auto",
                  float: "right",
                  transition: "none",
                  color: "white",
                  opacity: "1",
                  contain: "content",
                  width: "unset",
                  marginRight: "unset",
                }}
                onClick={(e) => {
                  this.props.onClose(e);
                }}
              >
                X
              </span>
            </div>
          </div>
          <div
            className="custom-popup-body pt-2 pb-2 pl-2 pr-2 display-vertically center"
            style={{
              height: "calc(100% - 45px)",
              overflowY: "auto",
              width: "80%",
              direction: dir,
            }}
          >
            <h6 style={{ textAlign: "start" }}>{this.props.t("OTPDec")}</h6>

            {localStorage
              .getItem(Constants.localStorageConstants.company_name)
              ?.toUpperCase() === "SIFS" ? (
              <div
                className="form-group container-input-with-password"               
              >
                {this.state.OtpSIB.map((_, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    maxLength="1"
                    value={this.state.OtpSIB[index]}
                    onChange={(e) => this.handleChange(e, index)}
                    className="otp-input"
                    autoComplete="off"
                  />
                ))}
              </div>
            ) : (
              <input
                className="input-textbox mb-2"
                style={{ marginTop: "auto" }}
                type="password"
                name="otp"
                autocomplete="off"
                maxLength={
                  localStorage
                    .getItem(Constants.localStorageConstants.company_name)
                    .toUpperCase() === "SIFS"
                    ? "5"
                    : "100"
                }
                placeholder={this.props.t("otpDesc")}
                value={this.props.otp}
                onChange={(e) => {
                  e.preventDefault();
                  this.setState({ otp: e.target.value });
                }}
              />
            )}

            <div
              style={{
                display: "flex",
                marginBottom: "auto",
                marginTop: "15px",
                width: "100%",
              }}
            >
              {localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "SIFS" ? (
                <button
                  className="btn custom-btn-cancel mr-2 ml-2"
                  style={{ width: "43%" }}
                  disabled={this.state.isDisabled}
                  onClick={(event) => {
                    event.preventDefault();
                    this.reSendOTP();
                  }}
                >
                  {this.props.t("ReSendOTP")} {"  "}{" "}
                  {this.props.i18n.language === "ar"
                    ? this.state.isDisabled && `  ${this.state.timer} ثانية`
                    : this.state.isDisabled && `in  ${this.state.timer}s`}
                </button>
              ) : null}
              <button
                className="btn custom-btn-cancel mr-2 ml-2"
                style={{ contain: "content", width: "45%" }}
                onClick={() => {
                  this.props.callRegistrationsOTP(
                    this.props.onClose,
                    localStorage
                      .getItem(Constants.localStorageConstants.company_name)
                      ?.toUpperCase() === "SIFS"
                      ? this.state.OtpSIB[0] +
                          this.state.OtpSIB[1] +
                          this.state.OtpSIB[2] +
                          this.state.OtpSIB[3] +
                          this.state.OtpSIB[4]
                      : this.state.otp
                  );
                }}
              >
                {this.props.t("sendOtp")}
              </button>
            </div>

            <div style={{ marginBottom: "16px", textAlign: "-webkit-center" }}>
              <button
                className="link"
                style={{
                  marginLeft: "10px",
                  marginRight: "10px",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={(e) => this.props.onClose(e)}
              >
                {this.props.t("cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(OtpPopup);
